<template>
	<div>
		<div style="width: 100%;height: 463px;">
			<div class="mq-top-item">
				<div class="">
					<el-radio-group @input="chooserRadio" v-model="radio" size="medium" style="margin-bottom: 20px;">
						<el-radio :label="0">苗情</el-radio>
						<el-radio :label="1">虫情</el-radio>
						<el-radio :label="2">病害</el-radio>
					</el-radio-group>
					<div class="mq-top-left-map">
						<div id="container"></div>
					</div>
				</div>
				<div class="">
					<div class="mq-top-cont-top">
						<div class="mq-top-cont-img">
							<img src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1701744536550.png" alt="">
						</div>
						<div class="mq-top-cont-text">
							<p>实时{{radio==0?'苗情':radio==1?'虫情':'病情'}}分析</p>
						</div>
						<div class="mq-top-cont-hr"></div>
					</div>
					<div v-if="showDataList.createTime" style="display: flex;margin-top: 25px;">
						<el-image style="width: 208px;height: 193px;margin-right: 20px;" :src="showDataList.imagesUrl"
							lazy :preview-src-list="srcList">
						</el-image>
						<div class="mq-cont-bottom-text">
							<div>采集于：</div>
							{{showDataList.createTime}}
						</div>
					</div>
				</div>
				<div class="">
					<div class="mq-top-cont-top">
						<div class="mq-top-cont-img">
							<img src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1701744536550.png" alt="">
						</div>
						<div class="mq-top-cont-text">
							<p>实时{{radio==0?'苗情':radio==1?'虫情':'病情'}}</p>
						</div>
						<div class="mq-top-cont-hr"></div>
					</div>
					<div class="mq-top-cont-list">
						<div v-for="(item,index) in mqDataList" :key="index" @click="choosermqDataList(item)">
							<el-image style="width: 72px;height: 72px;margin-right: 20px;" :src="item.imagesUrl" lazy
								:preview-src-list="srcList">
							</el-image>
							<div class="mq-top-cont-list-text">
								<div>{{radio==0?'苗情':radio==1?'虫情':'病情'}}{{item.name+index}}</div>
								<div style="display: flex;justify-content: space-between;margin-top: 30px;">
									<div>数量: {{item.num}}</div>
									<div>{{item.createTime}}</div>
								</div>
							</div>
						</div>
						<div v-if="mqDataList.length==0">
							<el-empty :image-size="75" description="暂无设备"
							image="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1705376475598.png"></el-empty>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-show="radio==0" class="mq-bottom-item">
			<div id="mainOne" class="echart-style"></div>
			<div id="mainTwo" class="echart-style"></div>
			<div id="mainThree" class="echart-style"></div>
			<div id="mainFour" class="echart-style"></div>
			<div id="mainFive" class="echart-style"></div>
			<div id="mainSix" class="echart-style"></div>
		</div>
		<div v-show="radio==1" class="" style="width: 100%;">
			<div class="mq-tip-box-bg">
				<img src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1701747283627.png" alt="" />
				<div>
					实时虫情趋势分析
				</div>
			</div>
			<div id="mainSeven" style="width: 100%;height: 185px;"></div>
		</div>
	</div>
</template>


<script type="text/javascript"
	src="https://webapi.amap.com/maps?v=2.0&key=d5571f8dd4961fc899fa1cef60e294d6&plugin=AMap.CitySearch"></script>
<script>
	import * as echarts from 'echarts';
	export default {
		name: 'app',
		components: {},
		data() {
			return {
				radio: 0,
				showDataList: {},
				mqDataList: [{
					imagesUrl: 'https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1702524575253.jpg',
					name: '名称',
					num: '20',
					createTime: '2023-06-06 12:00:00'
				}, {
					imagesUrl: 'https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1702524575253.jpg',
					name: '名称',
					num: '20',
					createTime: '2023-06-05 12:00:00'
				}, {
					imagesUrl: 'https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1702524575253.jpg',
					name: '名称',
					num: '20',
					createTime: '2023-06-04 12:00:00'
				}, {
					imagesUrl: 'https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1702524575253.jpg',
					name: '名称',
					num: '20',
					createTime: '2023-06-03 12:00:00'
				}, {
					imagesUrl: 'https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1702524575253.jpg',
					name: '名称',
					num: '20',
					createTime: '2023-06-02 12:00:00'
				}, {
					imagesUrl: 'https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1702524575253.jpg',
					name: '名称',
					num: '20',
					createTime: '2023-06-01 12:00:00'
				}],
				srcList: ['https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1702524575253.jpg']
			};
		},
		mounted() {
			this.initMainOne()
			this.initMainTwo()
			this.initMainThree()
			this.initMainFour()
			this.initMainFive()
			this.initMainSix()
			// this.initMainSeven()
			this.newMap()
			console.log('孢子mounted')
			this.showDataList = this.mqDataList[0];
		},
		methods: {
			chooserRadio(e) {
				console.log('chooserRadio---', e)
				if (e == 1) {
					this.$nextTick(function() {
						this.initMainSeven()
					})
				}
			},
			choosermqDataList(item) {
				this.showDataList = item;
			},
			initMainOne() {
				var chartDom = document.getElementById('mainOne');
				var myChart = echarts.init(chartDom);
				var option;
				option = {
					title: {
						text: '株高统计',
						left: 'left',
						top: 'top',
						textStyle: {
							fontSize: 20,
							fontWeight: 500,
							color: '#FFFFFF'
						}
					},
					visualMap: [{
						show: false,
						type: 'continuous',
						dimension: 0,
						min: 0,
						max: 3,
						inRange: {
							color: ['rgba(0, 100, 251, 1)', 'rgba(33, 228, 255, 1)'],
						}
					}],
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'cross',
						}
					},
					color: ['rgba(24, 89, 255, 0.32)'],
					grid: {
						left: '3%',
						right: '3%',
						top: '30%',
						bottom: '3%',
						containLabel: true
					},
					xAxis: [{
						type: 'category',
						boundaryGap: false,
						data: ['01:00', '02:00', '03:00', '04:00'],
						axisTick: {
							show: false,
							alignWithLabel: true
						}
					}],
					yAxis: [{
						type: 'value',
						name: '单位:mm',
						axisLine: {
							show: true
						},
						splitLine: {
							lineStyle: {
								// 使用深浅的间隔色
								color: ['rgba(70, 90, 100, 0.67)', '#ffffff00']
							}
						}
					}],
					series: [{
						name: '',
						type: 'line',
						data: [20, 90, 130, 220],
						tooltip: {
							valueFormatter: function(value) {
								return value + ' mm';
							}
						},
						areaStyle: {
							color: {
								type: 'linear',
								x: 0,
								y: 0,
								x2: 0,
								y2: 2,
								colorStops: [{
									offset: 0,
									color: 'rgba(24, 89, 255, 0.32)' // 0% 处的颜色
								}, {
									offset: 1,
									color: 'rgba(33, 228, 255, 0)' // 100% 处的颜色
								}],
								global: false // 缺省为 false
							}
						}
					}]
				};
				option && myChart.setOption(option);
			},
			initMainTwo() {
				var chartDom = document.getElementById('mainTwo');
				var myChart = echarts.init(chartDom);
				var option;
				option = {
					title: {
						text: '胸径统计',
						left: 'left',
						top: 'top',
						textStyle: {
							fontSize: 20,
							fontWeight: 500,
							color: '#FFFFFF'
						}
					},
					visualMap: [{
						show: false,
						type: 'continuous',
						dimension: 0,
						min: 0,
						max: 3,
						inRange: {
							color: ['rgba(0, 100, 251, 1)', 'rgba(33, 228, 255, 1)'],
						}
					}],
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'cross',
						}
					},
					color: ['rgba(24, 89, 255, 0.32)'],
					grid: {
						left: '3%',
						right: '3%',
						top: '30%',
						bottom: '3%',
						containLabel: true
					},
					xAxis: [{
						type: 'category',
						boundaryGap: false,
						data: ['01:00', '02:00', '03:00', '04:00'],
						axisTick: {
							show: false,
							alignWithLabel: true
						}
					}],
					yAxis: [{
						type: 'value',
						name: '单位:mm',
						axisLine: {
							show: true
						},
						splitLine: {
							lineStyle: {
								// 使用深浅的间隔色
								color: ['rgba(70, 90, 100, 0.67)', '#ffffff00']
							}
						}
					}],
					series: [{
						name: '',
						type: 'line',
						data: [20, 90, 130, 220],
						tooltip: {
							valueFormatter: function(value) {
								return value + ' mm';
							}
						},
						areaStyle: {
							color: {
								type: 'linear',
								x: 0,
								y: 0,
								x2: 0,
								y2: 2,
								colorStops: [{
									offset: 0,
									color: 'rgba(24, 89, 255, 0.32)' // 0% 处的颜色
								}, {
									offset: 1,
									color: 'rgba(33, 228, 255, 0)' // 100% 处的颜色
								}],
								global: false // 缺省为 false
							}
						}
					}]
				};
				option && myChart.setOption(option);
			},
			initMainThree() {
				var chartDom = document.getElementById('mainThree');
				var myChart = echarts.init(chartDom);
				var option;
				option = {
					title: {
						text: '叶长统计',
						left: 'left',
						top: 'top',
						textStyle: {
							fontSize: 20,
							fontWeight: 500,
							color: '#FFFFFF'
						}
					},
					visualMap: [{
						show: false,
						type: 'continuous',
						dimension: 0,
						min: 0,
						max: 3,
						inRange: {
							color: ['rgba(0, 100, 251, 1)', 'rgba(33, 228, 255, 1)'],
						}
					}],
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'cross',
						}
					},
					color: ['rgba(24, 89, 255, 0.32)'],
					grid: {
						left: '3%',
						right: '3%',
						top: '30%',
						bottom: '3%',
						containLabel: true
					},
					xAxis: [{
						type: 'category',
						boundaryGap: false,
						data: ['01:00', '02:00', '03:00', '04:00'],
						axisTick: {
							show: false,
							alignWithLabel: true
						}
					}],
					yAxis: [{
						type: 'value',
						name: '单位:mm',
						axisLine: {
							show: true
						},
						splitLine: {
							lineStyle: {
								// 使用深浅的间隔色
								color: ['rgba(70, 90, 100, 0.67)', '#ffffff00']
							}
						}
					}],
					series: [{
						name: '',
						type: 'line',
						data: [20, 90, 130, 220],
						tooltip: {
							valueFormatter: function(value) {
								return value + ' mm';
							}
						},
						areaStyle: {
							color: {
								type: 'linear',
								x: 0,
								y: 0,
								x2: 0,
								y2: 2,
								colorStops: [{
									offset: 0,
									color: 'rgba(24, 89, 255, 0.32)' // 0% 处的颜色
								}, {
									offset: 1,
									color: 'rgba(33, 228, 255, 0)' // 100% 处的颜色
								}],
								global: false // 缺省为 false
							}
						}
					}]
				};
				option && myChart.setOption(option);
			},
			initMainFour() {
				var chartDom = document.getElementById('mainFour');
				var myChart = echarts.init(chartDom);
				var option;
				option = {
					title: {
						text: '叶宽统计',
						left: 'left',
						top: 'top',
						textStyle: {
							fontSize: 20,
							fontWeight: 500,
							color: '#FFFFFF'
						}
					},
					visualMap: [{
						show: false,
						type: 'continuous',
						dimension: 0,
						min: 0,
						max: 3,
						inRange: {
							color: ['rgba(0, 100, 251, 1)', 'rgba(33, 228, 255, 1)'],
						}
					}],
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'cross',
						}
					},
					color: ['rgba(24, 89, 255, 0.32)'],
					grid: {
						left: '3%',
						right: '3%',
						top: '30%',
						bottom: '3%',
						containLabel: true
					},
					xAxis: [{
						type: 'category',
						boundaryGap: false,
						data: ['01:00', '02:00', '03:00', '04:00'],
						axisTick: {
							show: false,
							alignWithLabel: true
						}
					}],
					yAxis: [{
						type: 'value',
						name: '单位:mm',
						axisLine: {
							show: true
						},
						splitLine: {
							lineStyle: {
								// 使用深浅的间隔色
								color: ['rgba(70, 90, 100, 0.67)', '#ffffff00']
							}
						}
					}],
					series: [{
						name: '',
						type: 'line',
						data: [20, 90, 130, 220],
						tooltip: {
							valueFormatter: function(value) {
								return value + ' mm';
							}
						},
						areaStyle: {
							color: {
								type: 'linear',
								x: 0,
								y: 0,
								x2: 0,
								y2: 2,
								colorStops: [{
									offset: 0,
									color: 'rgba(24, 89, 255, 0.32)' // 0% 处的颜色
								}, {
									offset: 1,
									color: 'rgba(33, 228, 255, 0)' // 100% 处的颜色
								}],
								global: false // 缺省为 false
							}
						}
					}]
				};
				option && myChart.setOption(option);
			},
			initMainFive() {
				var chartDom = document.getElementById('mainFive');
				var myChart = echarts.init(chartDom);
				var option;
				option = {
					title: {
						text: '叶面积统计',
						left: 'left',
						top: 'top',
						textStyle: {
							fontSize: 20,
							fontWeight: 500,
							color: '#FFFFFF'
						}
					},
					visualMap: [{
						show: false,
						type: 'continuous',
						dimension: 0,
						min: 0,
						max: 3,
						inRange: {
							color: ['rgba(0, 100, 251, 1)', 'rgba(33, 228, 255, 1)'],
						}
					}],
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'cross',
						}
					},
					color: ['rgba(24, 89, 255, 0.32)'],
					grid: {
						left: '3%',
						right: '3%',
						top: '30%',
						bottom: '3%',
						containLabel: true
					},
					xAxis: [{
						type: 'category',
						boundaryGap: false,
						data: ['01:00', '02:00', '03:00', '04:00'],
						axisTick: {
							show: false,
							alignWithLabel: true
						}
					}],
					yAxis: [{
						type: 'value',
						name: '单位:mm',
						axisLine: {
							show: true
						},
						splitLine: {
							lineStyle: {
								// 使用深浅的间隔色
								color: ['rgba(70, 90, 100, 0.67)', '#ffffff00']
							}
						}
					}],
					series: [{
						name: '',
						type: 'line',
						data: [20, 90, 130, 220],
						tooltip: {
							valueFormatter: function(value) {
								return value + ' mm';
							}
						},
						areaStyle: {
							color: {
								type: 'linear',
								x: 0,
								y: 0,
								x2: 0,
								y2: 2,
								colorStops: [{
									offset: 0,
									color: 'rgba(24, 89, 255, 0.32)' // 0% 处的颜色
								}, {
									offset: 1,
									color: 'rgba(33, 228, 255, 0)' // 100% 处的颜色
								}],
								global: false // 缺省为 false
							}
						}
					}]
				};
				option && myChart.setOption(option);
			},
			initMainSix() {
				var chartDom = document.getElementById('mainSix');
				var myChart = echarts.init(chartDom);
				var option;
				option = {
					title: {
						text: '株高统计',
						left: 'left',
						top: 'top',
						textStyle: {
							fontSize: 20,
							fontWeight: 500,
							color: '#FFFFFF'
						}
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						}
					},
					grid: {
						left: '3%',
						right: '3%',
						top: '30%',
						bottom: '3%',
						containLabel: true
					},
					xAxis: [{
						type: 'category',
						data: ['01:00', '02:00', '03:00', '04:00'],
						axisTick: {
							alignWithLabel: true
						},
					}],
					yAxis: [{
						type: 'value',
						name: '単位:mm',
						splitLine: {
							show: true
						},
						splitLine: {
							lineStyle: {
								// 使用深浅的间隔色
								color: ['rgba(70, 90, 100, 0.67)', '#ffffff00']
							}
						},
					}],
					series: [{
						type: 'bar',
						barWidth: '20px',
						label: {
							show: true,
							position: 'top',
							color: "rgba(255, 255, 255, 1.0)"
						},
						data: [20, 90, 130, 220],
						showBackground: false,
						tooltip: {
							valueFormatter: function(value) {
								return value + ' mm';
							}
						},
						itemStyle: {
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
								offset: 0,
								color: '#2378f7'
							}, {
								offset: 0.7,
								color: '#2378f7'
							}, {
								offset: 1,
								color: '#83bff6'
							}])
						},
						emphasis: {
							itemStyle: {
								color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
									offset: 0,
									color: '#83bff6'
								}, {
									offset: 0.5,
									color: '#188df0'
								}, {
									offset: 1,
									color: '#188df0'
								}])
							},
						}
					}]
				};
				option && myChart.setOption(option);
			},
			initMainSeven() {
				var chartDom = document.getElementById('mainSeven');
				var myChart = echarts.init(chartDom);
				var option;
				option = {
					// title: {
					// 	text: '叶面积统计',
					// 	left: 'left',
					// 	top: 'top',
					// 	textStyle: {
					// 		fontSize: 20,
					// 		fontWeight: 500,
					// 		color: '#FFFFFF'
					// 	}
					// },
					visualMap: [{
						show: false,
						type: 'continuous',
						dimension: 0,
						min: 0,
						max: 3,
						inRange: {
							color: ['rgba(0, 100, 251, 1)', 'rgba(33, 228, 255, 1)'],
						}
					}],
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'cross',
						}
					},
					color: ['rgba(24, 89, 255, 0.32)'],
					grid: {
						left: '3%',
						right: '3%',
						top: '30%',
						bottom: '3%',
						containLabel: true
					},
					xAxis: [{
						type: 'category',
						boundaryGap: false,
						data: ['01:00', '02:00', '03:00', '04:00'],
						axisTick: {
							show: false,
							alignWithLabel: true
						}
					}],
					yAxis: [{
						type: 'value',
						name: '单位:mm',
						axisLine: {
							show: true
						},
						splitLine: {
							lineStyle: {
								// 使用深浅的间隔色
								color: ['rgba(70, 90, 100, 0.67)', '#ffffff00']
							}
						}
					}],
					series: [{
						name: '',
						type: 'line',
						data: [20, 90, 130, 220],
						tooltip: {
							valueFormatter: function(value) {
								return value + ' mm';
							}
						},
						areaStyle: {
							color: {
								type: 'linear',
								x: 0,
								y: 0,
								x2: 0,
								y2: 2,
								colorStops: [{
									offset: 0,
									color: 'rgba(24, 89, 255, 0.32)' // 0% 处的颜色
								}, {
									offset: 1,
									color: 'rgba(33, 228, 255, 0)' // 100% 处的颜色
								}],
								global: false // 缺省为 false
							}
						}
					}]
				};
				option && myChart.setOption(option);
			},
			newMap() {
				const scripts = [
					'https://webapi.amap.com/maps?v=2.0&key=d5571f8dd4961fc899fa1cef60e294d6'
					// 'https://a.amap.com/jsapi_demos/static/resource/heatmapData.js'
				];

				scripts.forEach((src) => {
					const script = document.createElement('script');
					script.src = src;
					script.onload = () => {
						// 外部 JS 文件加载成功后的回调函数
						// console.log('苗情newMap加载成功');

						// 这是中心点的经纬度
						// 业务中应该是获取当前位置
						var map = new AMap.Map("container", {
							resizeEnable: true,
							center: [103.830328, 36.079283],
							zoom: 10,
							mapStyle: 'amap://styles/whitesmoke'
						});

						// 点标记显示内容，HTML要素字符串
						const markerContent = '' +
							'<div class="custom-content-marker">' +
							'   <img src="https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1701763768056.png">' +
							'</div>';

						const position = new AMap.LngLat(103.830328, 36.079283); // Marker经纬度
						const marker = new AMap.Marker({
							position: position,
							content: markerContent, // 将 html 传给 content
							offset: new AMap.Pixel(-13, -30) // 以 icon 的 [center bottom] 为原点
						});
						map.add(marker);


					};
					script.onerror = (err) => {
						// 外部 JS 文件加载失败后的回调函数
						// console.error('外部 JS 文件加载失败', err);
					};
					document.head.appendChild(script);
				});

			}
		}
	};
</script>

<!-- <style>
	@import url("https://a.amap.com/jsapi_demos/static/demo-center/css/demo-center.css");
</style> -->
<style>
	/* .mq-bottom-item>div {
		width: 32%;
		height: 218px;
		padding-top: 15px;
	} */

	.mq-bottom-item {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
	}

	.mq-top-right {
		background: rgba(0, 0, 0, 0.5);
	}

	.mq-top-cont-list-text {
		width: calc(100% - 92px);
		font-size: 16px;
		color: #FFFFFF;
		/* display: flex;
		justify-content: space-between; */
		/* line-height: 24px; */
	}

	.mq-top-cont-list img {
		width: 72px;
		height: 72px;
		margin-right: 20px;
	}

	.mq-top-cont-list>div {
		display: flex;
		margin-bottom: 21px;
	}

	.mq-top-cont-list {
		height: 380px;
		overflow: auto;
		scrollbar-width: thin;
		scrollbar-color: transparent transparent;
		margin-top: 25px;
	}

	.mq-top-cont-list::-webkit-scrollbar {
		width: 8px;
		background-color: transparent;
	}

	.mq-top-cont-list::-webkit-scrollbar-thumb {
		background-color: transparent;
	}

	.mq-top-cont-hr {
		width: 12px;
		height: 40px;
		border-bottom: 3px #18FEFE solid;
		margin-left: 3px;
	}

	.mq-top-cont-text {
		line-height: 44px;
		border-bottom: 1px rgba(255, 255, 255, 0.5) solid;
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: calc(100% - 50px);
		height: 40px;
		font-size: 16px;
		font-weight: bold;
	}

	.mq-top-cont-img {
		width: 34px;
		border-bottom: 3px #fff solid;
		padding: 12px 0 9px 0;
		text-align: center;
	}

	.mq-top-cont-img img {
		width: 20px;
		height: 20px;
	}

	.mq-top-cont-top {
		width: 100%;
		height: 40px;
		display: flex;
		background: rgba(0, 0, 0, 0.4);
	}

	.mq-top-left-map {
		width: 100%;
		height: 380px;
	}

	.mq-top-item>div {
		flex: 1;
		height: 460px;
		padding: 0 20px;
	}

	.mq-top-item {
		width: 100%;
		display: flex;
		justify-content: space-between;
	}

	/* 地图 */

	.custom-content-marker {
		position: relative;
		width: 34px;
		height: 34px;
	}

	.custom-content-marker img {
		width: 100%;
		height: 100%;
	}

	#container {
		width: 100%;
		height: 100%;
	}

	.echart-style {
		width: 32%;
		height: 218px;
		margin-top: 10px;
	}

	.mq-cont-bottom-text {
		font-size: 16px;
		color: #FFFFFF;
	}

	.mq-cont-bottom-text div {
		margin-bottom: 20px;
	}

	.mq-tip-box-bg {
		width: 100%;
		height: 44px;
		background: url(https://ossdaxing.oss-cn-chengdu.aliyuncs.com/daxing/1701757063603.png) no-repeat;
		background-size: 100% 100%;
		display: flex;
		align-items: center;
	}

	.mq-tip-box-bg img {
		width: 20px;
		height: 20px;
		margin-right: 7px;
	}

	.mq-tip-box-bg div {
		font-size: 16px;
		font-weight: bold;
		color: #fff;
	}
</style>